import {Tabs} from "antd";
import className from "classnames/bind";
import {FontAwesomeIcon} from "~/components";
import CategoryScores from "./CategoryScores";
import CoreWebVitals from "./CoreWebVitals";
import Opportunities from "./Opportunities";
import style from "../style/PageSpeed.module.scss";

const cn = className.bind(style);

/** Nội dung kết quả cho 1 strategy. */
function StrategyPanel({strat}) {
	if (!strat) return null;

	return (
		<div className={cn('panel')}>
			<CategoryScores scores={strat.scores} />
			<CoreWebVitals strat={strat} />
			<Opportunities items={strat.opportunities} />
		</div>
	);
}

/**
 * Kết quả PageSpeed: tab Mobile / Desktop. Dùng chung cho trang kiểm tra và modal
 * lịch sử (result.strategies.{mobile,desktop}).
 */
function PsiResult({result}) {
	if (!result || !result.strategies) return null;

	const {mobile, desktop} = result.strategies;

	const tabs = [
		{
			key: 'mobile',
			label: <span><FontAwesomeIcon icon="fa-light fa-mobile-screen" /> Mobile</span>,
			children: <StrategyPanel strat={mobile} />,
		},
		{
			key: 'desktop',
			label: <span><FontAwesomeIcon icon="fa-light fa-desktop" /> Desktop</span>,
			children: <StrategyPanel strat={desktop} />,
		},
	];

	return (
		<div className={cn('result')}>
			<Tabs items={tabs} defaultActiveKey="mobile" />
		</div>
	);
}

export default PsiResult;
